import { ModalWrapper, RenderWhen } from "../../../components";
import { SUBSCRIPTION_ACTIONS } from "../const";
import HashUnsubscriber from "./components/HashUnsubscriber";
import SubscriptionSelector from "./components/SubscriptionSelector";
import LoadingOverlay from "../../../components/LoadingOverlay";
import useSelectAllQueryHashes from "../hooks/useSelectAllQueryHashes";
import { SubscriptionHashes } from "../@types";
import {
  IExtractedFilesQueryParams,
  ISamplesQuery
} from "../../../hooks/@types";

const ManageHashSubscriptionDialog = ({
  action,
  hashes,
  samplesQuery,
  extractedSampleQuery,
  onClose
}: {
  action: string;
  hashes: SubscriptionHashes | Array<string>;
  samplesQuery?: ISamplesQuery | undefined;
  extractedSampleQuery?: IExtractedFilesQueryParams | undefined;
  onClose: () => void;
}) => {
  const {
    subscribeQueryHashes,
    unsubscribeQueryHashes,
    shouldUseQueryHashes,
    isLoadingQueryHashes
  } = useSelectAllQueryHashes(samplesQuery, extractedSampleQuery);

  const subscriptionHashes =
    shouldUseQueryHashes && subscribeQueryHashes
      ? subscribeQueryHashes
      : (hashes as SubscriptionHashes);

  const unsubscribeHashes =
    shouldUseQueryHashes && unsubscribeQueryHashes
      ? unsubscribeQueryHashes
      : (hashes as Array<string>);

  const isSubscriptionAction = action === SUBSCRIPTION_ACTIONS.SUBSCRIBE;

  const modalTitle = isSubscriptionAction
    ? "Subscribe to Hash Alert"
    : "Confirm Unsubscribe";

  const modalSize = isSubscriptionAction ? "lg" : undefined;

  return (
    <ModalWrapper
      id="manage_subscription__modal"
      data-testid="manage_subscription_modal"
      show
      title={modalTitle}
      onHide={() => onClose()}
      size={modalSize}
    >
      <RenderWhen
        condition={!isLoadingQueryHashes}
        fallback={<LoadingOverlay />}
      >
        {isSubscriptionAction ? (
          <SubscriptionSelector hashes={subscriptionHashes} onClose={onClose} />
        ) : (
          <HashUnsubscriber hashes={unsubscribeHashes} onClose={onClose} />
        )}
      </RenderWhen>
    </ModalWrapper>
  );
};

export default ManageHashSubscriptionDialog;
